// extracted by mini-css-extract-plugin
export default {"header":"styles_header__aLsAF","readAloudCoverButton":"styles_readAloudCoverButton__Q+ur4","playerOverlay":"styles_playerOverlay__LKwj+"};